import { shaderMaterial } from '@react-three/drei';
import { Color } from 'three';

const vertexShader = `
  uniform float pointSize;
  uniform float distance;

  void main() {
    float effectivePointSize =  pointSize / distance;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    gl_PointSize = max(effectivePointSize, 1.0);
  }
`;

const fragmentShader = `
  uniform vec3 color;
  uniform float opacity;
  void main() {
    gl_FragColor = vec4(color, opacity);
  }
`;

export const CustomPointsMaterial = shaderMaterial(
  {
    pointSize: 0.05,
    distance: 35,
    color: new Color(),
    opacity: 1,
    transparent: true,
  },
  vertexShader,
  fragmentShader,
);
